module.exports = __webpack_public_path__ + "static/media/banner1.8ab9ca35.png";